import {action, observable} from 'mobx';

import {SubstitutionSectionStore} from './SubstitutionSectionStore';

export class SubstitutionRootStore {

  @observable substitutions = [];
  constructor(initialState, rootStore) {
    this.substSectionStores = {};
    this.service = rootStore.services.substProductsAPI;
    this.rootStore = rootStore;
    this.initStore(initialState);
  }

  getSubstSectionStores = (parent) => {
    const productSkuID = parent.skuID;

    if (!this.substSectionStores[productSkuID]) {
      const substObjArr = this.findSubstObjects(productSkuID);

      if (substObjArr.length) {
        this.substSectionStores[productSkuID] = [];
        substObjArr.forEach(substObj => {
          this.substSectionStores[productSkuID].push(new SubstitutionSectionStore(parent, substObj, this.rootStore));
        });
      } else {
        return null;
      }
    }

    return this.substSectionStores[productSkuID];
  };

  findSubstObjects = (productSkuID) => {
    const substObjArr = this.substitutions.filter(obsolete => obsolete.commRef === productSkuID);

    return substObjArr.length ? substObjArr : [];
  };

  initStore(initialState) {
    const obsoleteIdArr = this.findObsoleteProducts(initialState);
    this.fetchSubstitutions(obsoleteIdArr);
  }

  findObsoleteProducts = (initialState) => {
    const obsoleteIdArr = [];

    if (Array.isArray(initialState) && initialState.length) {
      initialState.forEach(group => {

        group.products.forEach(product => {
          if (product.isObsolete && obsoleteIdArr.indexOf(product.skuID) === -1) {
            obsoleteIdArr.push(product.skuID);
          }
        });
      });
    
    }
    
    return obsoleteIdArr;
  };

  fetchSubstitutions = async (obsoleteIdArr) => {
    const { productSubstitutionsResponse, error } = 
      await this.service.getSubstitutionProducts(obsoleteIdArr);
    if(error) return this.setSubstitutions(null);
    const { substitutions } = productSubstitutionsResponse;
    this.setSubstitutions(substitutions);
  };

  @action.bound
  setSubstitutions(substitutions) {
    this.substitutions = !Array.isArray(substitutions) ? [] : substitutions;
  }
}